import { InsightDay, UserInsightsAvailability, userType } from "../../DTO";
import { Api } from "../api";

const convertDay = (data: any): InsightDay => ({
    id: Number(data?.id ?? 0),
    index: Number(data?.index ?? 0),
    name: String(data?.name ?? ""),
    date: String(data?.date ?? ""),
    isCurrentDay: Boolean(data?.is_current_day),
    isFuture: Boolean(data?.is_future),
    hasAnyData: Boolean(data?.has_any_data),
    pendingGoalCount: Number(data?.pending_goal_count ?? 0),
    dailyTaskIds: Array.isArray(data?.daily_task_ids)
        ? data.daily_task_ids.map(Number)
        : [],
    planElements: Array.isArray(data?.plan_elements)
        ? data.plan_elements.map((item: any) => ({
              dailyTaskId: Number(item?.daily_task_id ?? 0),
              taskId: Number(item?.task_id ?? 0),
              title: String(item?.title ?? "Plan element"),
              type: String(item?.type ?? ""),
              hasData: Boolean(item?.has_data),
          }))
        : [],
    percentage: Number(data?.percentage ?? 0),
    data: Object.fromEntries(
        Object.entries(data?.data ?? {}).map(([key, value]: [string, any]) => [
            key,
            { hasData: Boolean(value?.has_data), count: Number(value?.count ?? 0) },
        ]),
    ),
    measurements: Object.fromEntries(
        Object.entries(data?.measurements ?? {}).map(
            ([key, records]: [string, any]) => [
                key,
                Array.isArray(records)
                    ? records.map((record: any) => ({
                          id: Number(record?.id ?? 0),
                          createdAt: String(record?.created_at ?? ""),
                          stress:
                              record?.stress == null
                                  ? null
                                  : Number(record.stress),
                          mood:
                              record?.mood == null ? null : Number(record.mood),
                          weight:
                              record?.weight == null
                                  ? null
                                  : Number(record.weight),
                          waist:
                              record?.waist == null
                                  ? null
                                  : Number(record.waist),
                          bloodSugar:
                              record?.blood_sugar == null
                                  ? null
                                  : Number(record.blood_sugar),
                          systolic:
                              record?.sys == null ? null : Number(record.sys),
                          diastolic:
                              record?.dia == null ? null : Number(record.dia),
                      }))
                    : [],
            ],
        ),
    ),
});

export const GetUserInsightsAvailability = (
    user: userType,
    userId: number,
    weekId: number,
) =>
    new Promise<{ insights: UserInsightsAvailability }>((resolve, reject) => {
        new Api({
            method: "get",
            path: `user-insights/user/${userId}/week/${weekId}`,
            ignore404Redirect: true,
            header: { Authorization: `Bearer ${user.access_token}` },
        })
            .call()
            .then((response: any) => {
                const data = response?.data ?? {};
                resolve({
                    insights: {
                        userId: Number(data?.user_id ?? userId),
                        planOrderId: Number(data?.plan_order_id ?? 0),
                        week: {
                            id: Number(data?.week?.id ?? weekId),
                            index: Number(data?.week?.index ?? 0),
                        },
                        days: Array.isArray(data?.days) ? data.days.map(convertDay) : [],
                    },
                });
            })
            .catch((err: any) =>
                reject(err?.data?.message || err?.message || "Insights unavailable"),
            );
    });
